import type { SceneDesc } from '@seddi/ui-three-viewer';

/**
 * Create a mapping from piece/mesh name to entity ID for logo placement.
 * Supports both garmentPiece entities (by name) and model entities (by meshDecals).
 */
export const createPieceNameToEntityDict = (scene: SceneDesc): Record<string, string> => {
  const dict: Record<string, string> = {};

  for (const e of scene.children as any[]) {
    if (e.components?.garmentPiece) {
      dict[e.name] = e._id;
    }

    if (e.components?.model && (scene as any).models) {
      const modelId = e.components.model.model;
      const model = (scene as any).models.find((m: any) => m.id === modelId);
      const meshDecals: string[] | undefined = model?.meta?.meshDecals;
      if (meshDecals) {
        for (const name of meshDecals) {
          dict[name] = e._id;
        }
      }
    }
  }

  return dict;
};
